import { useCallback, useContext } from 'react';

import responseMeetingRemindButtonClick from '@hh.ru/analytics-js-events/build/xhh/employer/responses/resume_card/response_meeting_remind_button_click';
import { Card, Text } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import formatDate from 'Modules/formatDate';
import HumanDate, { ShowYear } from 'src/components/HumanDate';
import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import translation from 'src/components/translation';
import { TopicNegotiationInterviewInfo } from 'src/models/candidatesList';

const TrlKeys = {
    remind: 'resume.interview.schedule.remind',
    planned: 'resume.interview.schedule.planned',
};

interface Props {
    topicId: string;
    remindInfo: TopicNegotiationInterviewInfo;
    openRemindModal: () => void;
    closeMenu?: () => void;
}

const Remind: TranslatedComponent<Props> = ({ trls, topicId, remindInfo, openRemindModal, closeMenu }) => {
    const { lastEmployerStateExtName, vacancyId } = useContext(ResumeCardActionsContext);

    const handleOpenRemind = useCallback(() => {
        if (topicId && lastEmployerStateExtName) {
            responseMeetingRemindButtonClick({
                vacancyId,
                topicId,
                folderName: lastEmployerStateExtName,
            });
        }
        closeMenu?.();
        openRemindModal();
    }, [closeMenu, lastEmployerStateExtName, openRemindModal, topicId, vacancyId]);

    const scheduledTime = remindInfo.currentInterview?.scheduledTime || '';
    const scheduledDate = new Date(scheduledTime);
    const remindContent = remindInfo.currentInterview
        ? formatToReactComponent(trls[TrlKeys.planned], {
              '{0}': <HumanDate date={scheduledDate.toISOString()} showYear={ShowYear.NotCurrent} />,
              '{1}': <span suppressHydrationWarning>{formatDate(scheduledDate, 'HH:mm')}</span>,
          })
        : trls[TrlKeys.remind];

    return (
        <Card
            onClick={handleOpenRemind}
            borderRadius={16}
            padding={12}
            paddingLeft={16}
            hoverStyle="secondary"
            stretched
            data-qa="interview-reminder-link"
        >
            <Text style="primary" typography="label-2-regular">
                {remindContent}
            </Text>
        </Card>
    );
};

export default translation(Remind);
